import { IsOptional, IsEnum, IsUUID, IsString } from 'class-validator';
import { Transform } from 'class-transformer';
import { UserStatus } from '../enums';

// Nous ne pouvons pas étendre OffsetPaginationQueryDto si elle n'est pas dans user/domain ou shared/util pure.
// Si elle est dans shared/data-access/http, ça crée une dépendance vers data-access depuis domain? Non, data-access depend de domain.
// Shared/data-access/http doit être utilisé par data-access aussi.
// Idéalement on duplique ou on extrait la pagination dans shared/util/types.
// Pour l'instant, je vais redéfinir les champs de pagination de base ou assumer une interface.

export class QueryUsersDto {
  @IsOptional()
  page?: number;

  @IsOptional()
  limit?: number;

  @IsOptional()
  @IsUUID('4')
  establishmentId?: string;

  @IsOptional()
  @IsEnum(UserStatus)
  status?: UserStatus;

  @IsOptional()
  @IsString()
  email?: string;

  @IsOptional()
  @IsString()
  username?: string;

  @IsOptional()
  @Transform(({ value }: { value: any }) => (Array.isArray(value) ? value : [value]))
  @IsEnum(UserStatus, { each: true })
  includeStatuses?: UserStatus[];

  @IsOptional()
  @IsString()
  q?: string;

  @IsOptional()
  @IsString()
  sort?: string;

  @IsOptional()
  @IsString() // Or enum 'asc' | 'desc'
  order?: 'asc' | 'desc';
}

